export function normalizeConfiguredUrl(value, fallback = "/") {
  const text = String(value || "").trim();
  return text || fallback;
}

export function isInternalConfiguredUrl(value) {
  const target = normalizeConfiguredUrl(value, "");
  return target.startsWith("/") || target.startsWith("#/");
}

export function openConfiguredUrl(value, navigate, options = {}) {
  const target = normalizeConfiguredUrl(value, "");
  if (!target) return;

  if (target.startsWith("#/")) {
    navigate(target.slice(1));
    return;
  }

  if (target.startsWith("/")) {
    navigate(target);
    return;
  }

  if (target.startsWith("#")) {
    const node = document.getElementById(target.slice(1));
    if (node) node.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }

  window.open(
    target,
    options.newTab === false ? "_self" : "_blank",
    options.newTab === false ? undefined : "noopener,noreferrer"
  );
}

export function configuredHref(value, fallback = "/") {
  const target = normalizeConfiguredUrl(value, fallback);
  if (target.startsWith("#/")) return target;
  if (target.startsWith("/")) return `#${target}`;
  return target;
}

export function appendConfiguredQuery(value, key, queryValue, fallback = "/productos") {
  const target = normalizeConfiguredUrl(value, fallback);
  const separator = target.includes("?") ? "&" : "?";
  return `${target}${separator}${encodeURIComponent(key)}=${encodeURIComponent(queryValue)}`;
}
